import React from 'react';
import { Icon } from '@mui/material';
import { TaskReportIcon, CameraIndoorIcon } from 'global/components/PerformIcons';
import { get, size } from 'global/lib/lodash';
import { FinishedCircle, HalfCircle, OpenCircle } from 'global/components/icons';
import { FileUpload } from './DocumentContainer/FileUpload';
import { InteractiveDocument } from './DocumentContainer/InteractiveDocument';
import { CreateSBS } from '../admin/content/create-sbs';

export const FILEADD = {
  documentableType: 'library_file',
  id: '_file_',
  title: '+ Add Files',
  Component: FileUpload,
};

export const VIDEOADD = {
  documentableType: 'library_video',
  id: '_video_',
  title: '+ Add Videos',
  Component: FileUpload,
};

export const STEPADD = {
  documentableType: 'step_by_step',
  id: '_sbs_',
  title: '+ Add Step By Step',
  shouldCheckForMatches: false,
  Component: (p) => (
    <div style={{ padding: '0 16px' }}>
      <CreateSBS {...p} onClose={(updated) => !!updated && p.update && p.update()} />
    </div>
  ),
};

export const ADDTAB = {
  documentableType: '__add__',
  id: '_add_',
  children: [FILEADD, VIDEOADD, STEPADD],
};

export const INDOC = {
  documentableType: 'interactive_document',
  id: '_indoc_',
  Component: InteractiveDocument,
};

export const getIcon = (name, props = {}) => {
  if (name == 'checklist') {
    return <TaskReportIcon {...props} />;
  } else if (name === INDOC.documentableType) {
    return <CameraIndoorIcon {...props} />;
  }
  let str = name;
  if (name == 'step_by_step') {
    str = 'burst_mode';
  } else if (name == 'sow') {
    str = 'assignment';
  } else if (name == 'example') {
    str = 'thumbs_up_down';
  } else if (name === FILEADD.documentableType) {
    str = 'perm_media';
  } else if (name === VIDEOADD.documentableType) {
    str = 'ondemand_video';
  } else if (name === ADDTAB.documentableType) {
    str = 'add';
  }
  return <Icon {...props}>{str}</Icon>;
};

export const getIconCourse = (name, props = {}) => {
  let str = name;
  if (name == 'checklist') {
    return <TaskReportIcon {...props} />;
  } else if (name === INDOC.documentableType) {
    return <CameraIndoorIcon {...props} />;
  } else if (name == 'step_by_step') {
    str = 'burst_mode';
  } else if (name == 'sow') {
    str = 'assignment';
  } else if (name == 'example') {
    str = 'thumbs_up_down';
  } else if (name === FILEADD.documentableType) {
    str = 'perm_media';
  } else if (name === VIDEOADD.documentableType) {
    str = 'ondemand_video';
  } else if (name === ADDTAB.documentableType) {
    str = 'add';
  } else if (name === 'assessment') {
    return <TaskReportIcon {...props} />;
  }
  return <Icon {...props}>{str}</Icon>;
};

export const getCompletionIcon = (item, props = {}) => {
  const completion = get(item, 'completion', 0);

  if (completion === 0) {
    return <OpenCircle {...props} />;
  } else if (completion <= 50) {
    return <HalfCircle {...props} />;
  } else {
    return <FinishedCircle {...props} />;
  }
};

export const getReadIcon = (item, props = {}) => {
  const reads = get(item, 'reads', []);

  if (!reads || !size(reads)) {
    return <OpenCircle {...props} />;
  } else if (!!reads.find((r) => r.completedAt)) {
    return <FinishedCircle {...props} />;
  } else {
    return <HalfCircle {...props} />;
  }
};

export const getLabel = (name, obj = {}) => {
  const hasType = get(obj, 'meta.type');

  if (obj.title) {
    return obj.title;
  }

  if (hasType === 'quiz') {
    return 'Quiz';
  } else if (name == 'checklist') {
    return 'Checklist';
  } else if (name == 'step_by_step') {
    return 'Step By Step';
  } else if (name === INDOC.documentableType) {
    return 'Interactive';
  } else if (name === FILEADD.documentableType) {
    return 'Files';
  } else if (name === VIDEOADD.documentableType) {
    return 'Videos';
  } else if (obj.id === ADDTAB.id) {
    return 'Add';
  }
  return name;
};

export const getCategory = (data) => {
  return {
    checklist: get(data, 'checklist'),
    steps: get(data, 'steps'),
    examples: get(data, 'examples'),
    sow: get(data, 'scopeOfWork'),
  };
};
